const ANIMATED_ICON_NAME_REGEX = /[^a-z_]|^ic_|_ic_|^ic/g;
const VALID_COLOR_LAYER_NAMES = [
  'colour_primary',
  'colour_secondary',
  'colour_transparent',
];

export function validAnimationData(animationData) {
  let isValidAnimationData = false;
  const layers = animationData.layers;
  if (layers) {
    layers.forEach((layer) => {
      const shapes = layer.shapes;
      if (shapes) {
        shapes.forEach((shape) => {
          if (shape.hasOwnProperty('c')) {
            if (VALID_COLOR_LAYER_NAMES.includes(shape.nm)) {
              isValidAnimationData = true;
            } else {
              isValidAnimationData = false;
            }
          }
        });
      }
    });
  }
  return isValidAnimationData;
}

export function validAnimatedIconName(animatedIconName) {
  return animatedIconName && !animatedIconName.match(ANIMATED_ICON_NAME_REGEX);
}

export function getAnimatedIconNameError(animatedIconName) {
  if (!animatedIconName) {
    return 'Animated Illustration name cannot be empty';
  }

  if (animatedIconName.match(/[A-Z]/g)) {
    return 'Uppercase characters not allowed';
  }

  if (animatedIconName.match(/[\d]/g)) {
    return 'Numeric characters not allowed';
  }

  if (animatedIconName.match(/[^a-z_]/g)) {
    return 'Special characters except _ not allowed';
  }

  if (animatedIconName.match(/^ic_/g)) {
    return `Animated Illustration name shouldn't start with ic_`;
  }

  if (animatedIconName.match(/^ic/g)) {
    return `Animated Illustration name shouldn't start with ic`;
  }

  if (animatedIconName.match(/_ic_/g)) {
    return `Animated Illustration name shouldn't contain characters _ic_`;
  }
}
